
const map = {
    './.gitkeep': () => require('F:/work/shenzhen-h5/src/assets/.gitkeep'),
'./common/banner-img.jpg': () => require('F:/work/shenzhen-h5/src/assets/common/banner-img.jpg'),
'./common/download-bg.png': () => require('F:/work/shenzhen-h5/src/assets/common/download-bg.png'),
'./common/download-img.png': () => require('F:/work/shenzhen-h5/src/assets/common/download-img.png'),
'./common/download-logo.png': () => require('F:/work/shenzhen-h5/src/assets/common/download-logo.png'),
'./common/faq-icon/icon.png': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon.png'),
'./common/faq-icon/icon1-1.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon1-1.svg'),
'./common/faq-icon/icon1.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon1.svg'),
'./common/faq-icon/icon2.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon2.svg'),
'./common/faq-icon/icon3.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon3.svg'),
'./common/faq-icon/icon4.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon4.svg'),
'./common/faq-icon/icon5.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon5.svg'),
'./common/faq-icon/icon6.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon6.svg'),
'./common/faq-icon/icon7.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon7.svg'),
'./common/faq-icon/icon8.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon8.svg'),
'./common/faq-icon/icon9.svg': () => require('F:/work/shenzhen-h5/src/assets/common/faq-icon/icon9.svg'),
'./common/home-img01.png': () => require('F:/work/shenzhen-h5/src/assets/common/home-img01.png'),
'./common/icon.svg': () => require('F:/work/shenzhen-h5/src/assets/common/icon.svg'),
'./common/kefu.png': () => require('F:/work/shenzhen-h5/src/assets/common/kefu.png'),
'./fonts/NotoSansSC-Bold.ttf': () => require('F:/work/shenzhen-h5/src/assets/fonts/NotoSansSC-Bold.ttf'),
'./fonts/NotoSansSC-Bold.woff': () => require('F:/work/shenzhen-h5/src/assets/fonts/NotoSansSC-Bold.woff'),
'./fonts/NotoSansSC-Regular.ttf': () => require('F:/work/shenzhen-h5/src/assets/fonts/NotoSansSC-Regular.ttf'),
'./fonts/NotoSansSC-Regular.woff': () => require('F:/work/shenzhen-h5/src/assets/fonts/NotoSansSC-Regular.woff'),
'./fonts/YouSheBiaoTiHei.ttf': () => require('F:/work/shenzhen-h5/src/assets/fonts/YouSheBiaoTiHei.ttf'),
'./icon/asset.png': () => require('F:/work/shenzhen-h5/src/assets/icon/asset.png'),
'./icon/assets.png': () => require('F:/work/shenzhen-h5/src/assets/icon/assets.png'),
'./icon/dashboard.png': () => require('F:/work/shenzhen-h5/src/assets/icon/dashboard.png'),
'./icon/home.png': () => require('F:/work/shenzhen-h5/src/assets/icon/home.png'),
'./icon/icon-dashboard.png': () => require('F:/work/shenzhen-h5/src/assets/icon/icon-dashboard.png'),
'./icon/logo.svg': () => require('F:/work/shenzhen-h5/src/assets/icon/logo.svg'),
'./icon/notice.png': () => require('F:/work/shenzhen-h5/src/assets/icon/notice.png'),
'./icon/pannel.png': () => require('F:/work/shenzhen-h5/src/assets/icon/pannel.png'),
'./icon/profile.png': () => require('F:/work/shenzhen-h5/src/assets/icon/profile.png'),
'./icon/trade1.png': () => require('F:/work/shenzhen-h5/src/assets/icon/trade1.png'),
'./icon/tread.png': () => require('F:/work/shenzhen-h5/src/assets/icon/tread.png'),
'./img/img.png': () => require('F:/work/shenzhen-h5/src/assets/img/img.png'),
'./img/info-bg.png': () => require('F:/work/shenzhen-h5/src/assets/img/info-bg.png')
};

module.exports = (id) => {
    if (map[id]) return map[id]();
    else {
        const e = new Error("Cannot find module '" + id + "'");
        e.code = 'MODULE_NOT_FOUND';
        throw e;
    }
};
